import React from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';
import { FiChevronUp } from 'react-icons/fi';
import QcastApi from '../../store/qcasts/api';
import { useBoundStore } from '../../store';

interface ResponsesPanelProps {
  responseCount: any[];
  showComponent: boolean;
  setShowResponses: (status: boolean)=> void;
}

interface ResponseProps {
  name: string;
  timestamp: string;
  timeAgo: string;
  avatarSrc: string;
  interviewId:string;
  onSelected:()=>void;
}

const PanelContainer = styled.div<{hide: boolean}>`
  display: ${props => !props.hide ? 'none' : 'flex'};
  flex-direction: column;
  gap: 16px;
  padding: 24px 16px;
  width: 240px;
  max-height: 400px;
  overflow-y:scroll;
  background-color: ${theme.colors.transparentWhite};
  border-radius: ${theme.borderRadius.large};
  box-shadow: ${theme.shadows.responseShadow};
  position: absolute;
  top:70px;
  right: 20px;
  transform: translateY(-10px);
  transition: opacity 0.3s ease, transform 0.3s ease, visibility 0.3s;
`;

const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  border-radius: ${theme.borderRadius.pill};
`;

const HeaderTitle = styled.h3`
  font-family: ${theme.fonts.primary};
  font-weight: ${theme.fontWeights.bold};
  font-size: ${theme.fontSizes.md};
  color: ${theme.colors.gray[700]};
  flex: 1;
`;

const ResponseCount = styled.span`
  font-family: ${theme.fonts.primary};
  font-weight: ${theme.fontWeights.regular};
  font-size: ${theme.fontSizes.md};
  color: var(--Grey-757575, #757575);

`;

const ExpandIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const ResponsesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ResponseItem = styled.div`
  width: 208px;
  height: 51px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px;
  border-radius: ${theme.borderRadius.small};
  background-color: ${theme.colors.transparentWhite};
  box-shadow: ${theme.shadows.medium};
  cursor: pointer;
`;

const AvatarContainer = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
  box-shadow: ${theme.shadows.avatarShadow};
`;

const Avatar = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ResponseContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const ResponderName = styled.span`
  font-family: ${theme.fonts.primary};
  font-weight: ${theme.fontWeights.bold};
  font-size: ${theme.fontSizes.md};
  color: ${theme.colors.gray[800]};
`;

const ResponseMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const TimeStamp = styled.span`
  font-family: ${theme.fonts.primary};
  font-weight: ${theme.fontWeights.regular};
  font-size: ${theme.fontSizes.sm};
  color: ${theme.colors.gray[500]};
`;

const TimeDot = styled.div`
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: ${theme.colors.gray[400]};
`;

const TimeAgo = styled.span`
  font-family: ${theme.fonts.primary};
  font-weight: ${theme.fontWeights.regular};
  font-size: ${theme.fontSizes.sm};
  color: ${theme.colors.gray[500]};
`;

const Response: React.FC<ResponseProps> = ({ name, timestamp, timeAgo, avatarSrc,interviewId,onSelected }) => {
  const { setQcastView,setQcastLoading,setResponseVideo } = useBoundStore();
    
  const interviewDteails=async(id)=>{
    try {
       setQcastLoading(true);

    const response=await QcastApi.getResponseDeepCopy(localStorage.getItem("qcastId"),id);
    setQcastView("response")
    onSelected()
    setResponseVideo(response.data.responseVideos)
    } catch (error) {
      console.log(error)
    }finally{
setQcastLoading(false);
    }
   
    
  }
  return (
    <ResponseItem onClick={()=>{interviewDteails(interviewId)}}>
      <AvatarContainer>
        <Avatar src={avatarSrc} alt={name} />
      </AvatarContainer>
      <ResponseContent>
        <ResponderName>{name}</ResponderName>
        <ResponseMeta>
          <TimeStamp>{timestamp}</TimeStamp>
          {/* <TimeDot /> */}
          <TimeAgo>{timeAgo}</TimeAgo>
        </ResponseMeta>
      </ResponseContent>
    </ResponseItem>
  );
};

export const ResponsesPanel: React.FC<ResponsesPanelProps> = ({ responseCount=[], showComponent, setShowResponses }) => {
  return (
    <PanelContainer hide={showComponent}>
      <HeaderRow>
        <HeaderTitle>Responses</HeaderTitle>
        <ResponseCount>{responseCount.length}</ResponseCount>
        <ExpandIcon onClick={()=>{setShowResponses(false)}}>
          <FiChevronUp color={"#000"} size={16}  />
        </ExpandIcon>
      </HeaderRow>
      <ResponsesList>
       { responseCount.map((res,index)=>(<Response 
        key={index}
          name={res.responsorProfileName}
          timestamp={res.responseDate} 
          timeAgo="" 
          avatarSrc={res.profilePicAnswerer}
          interviewId={res.interviewId}
          onSelected={()=>setShowResponses(false)}
        />))}
        
      
      </ResponsesList>
    </PanelContainer>
  );
}; 